import { User } from './../../models/user.model';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserService {

  baseUrlSite = environment.baseUrlSite;

  constructor(private http: HttpClient, private toastr: ToastrService) {}

  public create(user: any): Observable<User> {
    const service = 'registrar';
    return this.http.post<User>(this.baseUrlSite + service, user);
  }

  public toastSuccess(msg: string) {
    return this.toastr.success(msg);
  }

  public toastError(msg: string) {
    return this.toastr.error(msg);
  }
}
